import React from 'react';
import {Styles} from '../../../config/design/styles';
import { withStyles } from '@material-ui/core/styles';
import Button from "@material-ui/core/Button/Button";
import {Translate} from "../../../config/Translate";
import { withSnackbar } from 'notistack';
import withWidth from "@material-ui/core/withWidth/withWidth";
import IconButton from "@material-ui/core/IconButton/IconButton";
import AddBox from "@material-ui/icons/AddBox";
import Dialog from "@material-ui/core/Dialog/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText/DialogContentText";
import DialogActions from "@material-ui/core/DialogActions/DialogActions";
import {currencySymbol} from "../../../config/values";
import CurrencyTextField from "@unicef/material-ui-currency-textfield";
import PaymentIcon from '@material-ui/icons/Payment';
import {defaultVariabls} from "../../../config";
import axios from "axios";
import {updateRedux} from "../../../config/Security";
import LoadingButton from "../../components/elements/LoadingButton";
class ReturnMoneyDialog extends React.Component {
    state = {
        open:false,
        error:'',
        factor:this.props.factor,
        amount:this.props.factor.total_price_payed,
        amountR:this.props.factor.total_price_payed,
    };
    handleChange(e){
        let target = e.target;
        let amountR = target.value.replace(/,/ig, '');
        let error = "";
        this.setState({
            error,
            amountR,
            amount: target.value
        });
    }
    async handleRequest(){
        let { amountR,factor} = this.state;
        let data = new FormData();
        data.append('id', factor.id);
        data.append('amount', amountR);

        let loginToken = localStorage.getItem('ACT');
        let config = {
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${loginToken}`
            }
        };
        await axios.post(`${defaultVariabls.url}/wallet/return/factor`, data, config)
            .then(response => {
                this.props.enqueueSnackbar(Translate.TransactionRecordSaved, {
                    variant: 'success',
                });
                updateRedux();
                this.setState({
                    loading:true,
                    SubmitLoading: false,
                });
                this.props.reload();

            })
            .catch(error => {
                console.log(error)
                this.props.enqueueSnackbar(Translate.TransactionRecordSavedError, {
                    variant: 'error',
                });
                this.setState({
                    loading:false,
                    SubmitLoading: false,
                    SubmitDraftLoading: false
                });
            });

    }

    handleSubmit(e){
        this.setState({
            SubmitLoading: true
        })
        this.handleRequest();

    }
    classes = this.props.classes;
    render(){
        let {error,open,amountR} = this.state;
        let {factor} = this.props;
        return(
            <>
                <Button
                    variant={"outlined"}
                    color="primary"
                    size="small"
                    style={this.props.style}
                    startIcon={<AddBox/>}
                    onClick={() => this.setState({open: !this.state.open})}
                >
                    {Translate.submitReturnMoney}
                </Button>

                <Dialog fullWidth maxWidth="sm" open={open} onClose={() => this.setState({open: !this.state.open})} aria-labelledby="form-dialog-title">
                    <DialogTitle id="form-dialog-title">{Translate.submitReturnMoney}</DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            {Translate.submitReturnMoneyFor}: <stong>{factor.number}</stong>
                        </DialogContentText>
                        <CurrencyTextField
                            variant="outlined"
                            required
                            fullWidth
                            margin="normal"
                            currencySymbol={currencySymbol}
                            decimalPlaces={0}
                            value={amountR}
                            id="amount"
                            label={Translate.amount}
                            name="amount"
                            onChange={this.handleChange.bind(this)}
                            error = {!!error}
                            helperText={error}
                        />
                    </DialogContent>
                    <DialogActions>
                        <LoadingButton
                            type="submit"
                            variant="contained"
                            startIcon={<PaymentIcon/>}
                            color="primary"
                            onClick = {this.handleSubmit.bind(this)}
                            loading = {this.state.SubmitLoading}
                        >
                            {Translate.Submit}
                        </LoadingButton>
                    </DialogActions>
                </Dialog>
            </>
        )
    }
}

export default withWidth()(withSnackbar(withStyles(Styles)(ReturnMoneyDialog)));